import { Component, Input } from "@angular/core";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { AuthModalComponent } from "src/app/auth/components/auth-modal/auth-modal.component";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent {
  @Input() customHeader: boolean = false;

  modalRef: MDBModalRef;

  constructor(private modalService: MDBModalService) {}

  openModal() {
    this.modalRef = this.modalService.show(AuthModalComponent, {
      ignoreBackdropClick: true,
      scroll: true,
    });
  }
}
